import Link from 'next/link';
import { memo } from 'react';
import { HeadlinePromoDesktopWidget } from '@/components/general/Header/DashboardPanel/HeadlinePromoSection/components/HeadlinePromoDesktopWidget';
import { Menu } from '@/components/general/Menu';
import { LabelsSection } from '@/components/LabelsSection';
import { Support } from '@/components/Support';
import { SwitchLanguage } from '@/components/SwitchLanguage';
import { generateLink } from '@/helpers/common';
import { useActiveHeadlinePromoConfig } from '@/modules/promotions/templates/HeadlinePromoTemplate/useActiveHeadlinePromoConfig';
import { useGetCommonStore } from '@/store';
import type { ServerLink } from '../../helpers';
import { AuthButtons } from '../AuthButtons';
import { HeaderSkeleton } from '../HeaderSkeleton';
import { Logo } from '../Logo';
import {
  ScAddons,
  ScHeaderButtonsGroup,
  ScHeaderColLeft,
  ScHeaderColRight,
  ScHeaderLogo,
  ScHeaderRow,
} from '../styled';
import { UserPanel } from '../UserBlock';

interface IHeaderContent {
  locale: string;
  links: ServerLink[];
}

export const HeaderContent = memo(({ locale, links }: IHeaderContent) => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUserPure = useCommonStore.use.pendingUserPure();
  const activeHeadlinePromoConfig = useActiveHeadlinePromoConfig();

  return (
    <ScHeaderRow>
      <ScHeaderColLeft>
        <ScHeaderLogo>
          <Link href={generateLink('/', locale)} id="logo">
            <Logo />
          </Link>
        </ScHeaderLogo>
        <Menu links={links} locale={locale} withStripe />
      </ScHeaderColLeft>
      {pendingUserPure ? (
        <ScHeaderColRight>
          <HeaderSkeleton />
        </ScHeaderColRight>
      ) : (
        <ScHeaderColRight>
          <ScHeaderButtonsGroup>
            <LabelsSection />
            {activeHeadlinePromoConfig && (
              <HeadlinePromoDesktopWidget config={activeHeadlinePromoConfig} />
            )}
            {isAuthenticated ? <UserPanel /> : <AuthButtons />}
            {!isAuthenticated && (
              <SwitchLanguage place="header" variant="compact" />
            )}
            <ScAddons>
              <Support />
            </ScAddons>
          </ScHeaderButtonsGroup>
        </ScHeaderColRight>
      )}
    </ScHeaderRow>
  );
});
